import { useGetPlaybookQuery } from '@carboncopyco/data';
import type { Playbook } from '@carboncopyco/types';
import { useParams } from 'react-router-dom';
import { PlaybookModal } from './PlaybookModal';
import { PlaybookModalProvider } from './PlaybookModalContext';

type UpdatePlaybookModalProps = {
  id: string;
  onClose: () => void;
  onSuccess?: (playbookId: Playbook['id']) => void;
};

export const UpdatePlaybookModal = ({
  id,
  onClose,
  onSuccess,
}: UpdatePlaybookModalProps) => {
  const { organizationId, workspaceId } = useParams();
  const { data: playbook } = useGetPlaybookQuery({
    organizationId,
    workspaceId,
    id,
  });
  return playbook?.name ? (
    <PlaybookModalProvider
      playbook={playbook}
      workspaceId={workspaceId}
    >
      <PlaybookModal
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </PlaybookModalProvider>
  ) : null;
};
